<div :class="classes">
    <slot name="header"></slot>
    <slot></slot>
    <slot name="footer"></slot>
</div>